export default "__VITE_ASSET__AdIwdhUi__"